import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { store } from '@/store';
import BasketCustomLineItemName from '@/ui/views/checkout/BasketCustomLineItemName.vue';
import BasketLineItemImage from '@/ui/views/checkout/BasketLineItemImage.vue';
import BasketLineItemPrice from '@/ui/views/checkout/BasketLineItemPrice.vue';
import BasketLineItemPOSDiscount from '@/ui/views/checkout/BasketLineItemPOSDiscount.vue';
import BasketLineItemPOSCustomLineItemProperties from '@/ui/views/checkout/BasketLineItemPOSCustomLineItemProperties.vue';
import BasketLineItemQuantity from '@/ui/views/checkout/BasketLineItemQuantity.vue';
import BasketLineItemRemove from '@/ui/views/checkout/BasketLineItemRemove.vue';
import BasketLineItemProperties from '@/ui/views/checkout/BasketLineItemProperties.vue';
import BasketLineItemTitle from '@/ui/views/checkout/BasketLineItemTitle.vue';
import UpdatePointOfSaleLineItemWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.UpdatePointOfSaleLineItemWebRequest;
import UpdatePointOfSaleCustomLineItemWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.UpdatePointOfSaleCustomLineItemWebRequest;
import RemoveFromBasketWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.RemoveFromBasketWebRequest;
import { BasketType } from '@/enums';
import { injectParentValidator } from '@/core/app.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemPOS',
  props: {
    lineItem: null,
    vatText: null
  },
  setup(__props: any) {

const props = __props as {
    lineItem: LineItemViewObject,
    vatText: string
}

injectParentValidator();


const immediateDelivery = ref<boolean>(props.lineItem.immediateDelivery);

watch(() => props.lineItem.immediateDelivery, () => {
    immediateDelivery.value = props.lineItem.immediateDelivery;
});

const isBasketLocked = computed(() => store.getters['basket/isBasketLocked']);
function removeFromBasket(request: RemoveFromBasketWebRequest) {
    store.dispatch('basket/removeFromBasket', request);
}

function updatePOSLineItem(request: UpdatePointOfSaleLineItemWebRequest, throwError = false) : Promise<void> {
    return store.dispatch('basket/updatePointOfSaleLineItem', Object.assign(request, { throwError }));
}

function updatePOSCustomLineItem(request: UpdatePointOfSaleCustomLineItemWebRequest) : Promise<void> {
    return store.dispatch('basket/updatePointOfSaleCustomLineItem', request);
}

function remove(lineItemId: number) {
    removeFromBasket({ id: lineItemId, basketType: BasketType.POS as any });
}

function onQuantityChange(newQuantity: number) {
    if (newQuantity === props.lineItem.quantity) {
        return;
    }
    updatePOSLineItem({
        id: props.lineItem.lineItemId,
        quantity: newQuantity,
        discount: props.lineItem.pointOfSaleDiscount,
        immediateDelivery: props.lineItem.immediateDelivery
    });
}

function onDiscountChange(newDiscount: string) {
    if (newDiscount === props.lineItem.pointOfSaleDiscount) {
        return;
    }
    updatePOSLineItem({
        id: props.lineItem.lineItemId,
        quantity: props.lineItem.quantity,
        discount: newDiscount,
        immediateDelivery: props.lineItem.immediateDelivery
    });
}

function onImmediateDeliveryChange(newImmediateDelivery: boolean) {
    if (newImmediateDelivery === props.lineItem.immediateDelivery) {
        return;
    }
    const oldValue = props.lineItem.immediateDelivery;

    updatePOSLineItem({
        id: props.lineItem.lineItemId,
        quantity: props.lineItem.quantity,
        discount: props.lineItem.pointOfSaleDiscount,
        immediateDelivery: newImmediateDelivery
    }, true).catch(() => {
        immediateDelivery.value = oldValue;
    });
}

function onCustomLineItemNameChange(name: string) {
    if (name === props.lineItem.productName) {
        return;
    }

    updatePOSCustomLineItem({
        id: props.lineItem.lineItemId,
        name,
        description: props.lineItem.comment,
        price: props.lineItem.unitPriceRaw.toString()
    });
}

function onCustomPropertiesChange(properties: { description: string, price: string}) {
    if (properties.description === props.lineItem.comment && properties.price === props.lineItem.unitPriceRaw.toString()) {
        return;
    }

    updatePOSCustomLineItem({
        id: props.lineItem.lineItemId,
        name: props.lineItem.productName,
        description: properties.description,
        price: properties.price
    });
}

function addService(lineItemId: number) : Promise<void> {
    const request = {
        basketType: BasketType.POS,
        createdViaLineItem: lineItemId
    };
    return store.dispatch('basket/addPointOfSaleService', request);
}


return { __sfc: true,props, immediateDelivery, isBasketLocked, removeFromBasket, updatePOSLineItem, updatePOSCustomLineItem, remove, onQuantityChange, onDiscountChange, onImmediateDeliveryChange, onCustomLineItemNameChange, onCustomPropertiesChange, addService, BasketCustomLineItemName, BasketLineItemImage, BasketLineItemPrice, BasketLineItemPOSDiscount, BasketLineItemPOSCustomLineItemProperties, BasketLineItemQuantity, BasketLineItemRemove, BasketLineItemProperties, BasketLineItemTitle }
}

})